import { useQuery } from 'react-query'
import * as Sentry from '@sentry/react'
import Cookies from 'js-cookie'
import { getUserPaymentMethods } from '../api'
import { ERROR_GETTING_USER_PAYMENT_METHODS } from '../errorConstants'

const useFetchUserPaymentMethods = (isEnabled = true) =>
    useQuery(['userPaymentMethods'], getUserPaymentMethods, {
        enabled: isEnabled,
        onError: (error) => {
            error.name = ERROR_GETTING_USER_PAYMENT_METHODS
            Sentry.captureException(error, {
                contexts: {
                    data: {
                        errorMessage:
                            "Error getting the user's payment methods",
                    },
                },
                user: {
                    id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
                },
            })
        },
        refetchOnWindowFocus: false,
    })

export default useFetchUserPaymentMethods
